export const controlSizes = ['mini', 'small', 'medium', 'large'] as const

type ControlSize = typeof controlSizes[number]

/**
 * Returns the control size's border radius.
 */
export function controlBorderRadius(size: ControlSize, full: boolean = false): number {
    if (full) {
        return Math.round(controlHeight(size) / 2)
    }

    switch (size) {
        case 'large':
            return 6
        case 'mini':
            return 2
        default:
            return 4
    }
}

/**
 * Returns the control size's font size in pixels.
 */
export function controlFontSize(size: ControlSize): number {
    switch (size) {
        case 'mini':
            return 12
        case 'small':
            return 14
        case 'medium':
            return 15
        case 'large':
            return 17
    }
}

export function controlFontShadow(size: ControlSize, opacity: number = 0.5): string {
    const fontSize = controlFontSize(size)
    const y = Math.round(fontSize / 25)
    const blur = Math.round(fontSize / 10)

    return `0 ${y}px ${blur}px rgba(0, 0, 0, ${opacity})`
}

/**
 * Returns the control size's height in pixels.
 */
export function controlHeight(size: ControlSize): number {
    switch (size) {
        case 'mini':
            return 16
        case 'small':
            return 34
        case 'medium':
            return 40
        case 'large':
            return 50
    }
}

export default ControlSize
